var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13508",
    "data-name": "Group 13508",
    transform: "translate(-360 -312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7552",
    "data-name": "Group 7552",
    transform: "translate(366.554 319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(2.211 2.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11956",
    "data-name": "Path 11956",
    d: "M32.124,24.733l-4.4-4.4a2.928,2.928,0,0,0-4.875,1.1,2.994,2.994,0,0,1-3.458,1.886c-3.145-.786-7.4-4.873-8.187-8.163A2.849,2.849,0,0,1,13.088,11.7a2.928,2.928,0,0,0,1.1-4.875l-4.4-4.4a3.14,3.14,0,0,0-4.246,0L2.554,5.408c-2.987,3.145.315,11.465,7.716,18.854S26.016,35.1,29.161,31.954l2.987-2.987A3.149,3.149,0,0,0,32.124,24.733Z",
    transform: "translate(-1.459 -1.595)",
    fill: "none",
    stroke: "#ff402d",
    strokeMiterlimit: 10,
    strokeWidth: 2.1
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 36,
    height: 36,
    transform: "translate(0.446)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1992",
    "data-name": "Rectangle 1992",
    width: 48,
    height: 48,
    transform: "translate(360 312)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1e4f76d91f75c16bd6a3c4a962db92f2.svg";
export { ForwardRef as ReactComponent };